import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import data from "../../../../assets/apiRoutes.json";
import { IM } from "../../../../const/constants";
import LotList from "../../../common/lists/LotList";
import { FillFilters, loadDatasource } from "../../../../common/Utils";
import { SearchLayout } from "../../../../wm/components/codes/itemDataEntry/Layout";

function LotTab(props) {
    var accessToken = props.oidc.user.access_token;
    const [triggerLoadData, setTriggerLoadData] = useState({
        filters: {
            RItem: props.rowId,
            Module: IM
        },
        filterTypes: {
            RItem: 'select',
            Module: 'select'
        }
    });
    return (
        <div className="FormMt">
            <LotList triggerLoadData={triggerLoadData} selectionMode="single" gridClassName="GridHeightTabPanel-with-toolbar" includeAllStatuses={props.includeAllStatuses} gridHeight={props.gridHeight} />
        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LotTab);